const takeConsultationsChoices = [
          { id: 'Toma consultas virtuales internacionales', name: 'Toma consultas virtuales internacionales' },
          { id: 'Toma consultas virtuales nacionales', name: 'Toma consultas virtuales nacionales' },
          { id: 'Toma consultas presenciales', name: 'Toma consultas presenciales' },
      ];
export default takeConsultationsChoices;
